import { FormControl, FormGroup } from '@angular/forms';
import { GroupEDWSummary } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`Group EDW Summary`,
  DATE_LABEL: $localize`Date`,
};

export const FILE_NAME = 'Group-EDW-Summary';

export const PDF_REPORT = {
  NAME: $localize`EDW Group Summary`,
  HEADER: {
    GROUP: $localize`Group` + ':',
    GROUP_NAME: $localize`Group Name` + ':',
    DATE: $localize`Date` + ':',
  },
  FOOTER: {
    TOTAL: $localize`Total`.toUpperCase() + ':',
  },
  COLUMNS: [
    $localize`Location`.toUpperCase(),
    $localize`Name`.toUpperCase(),
    $localize`Total Stops`.toUpperCase(),
    $localize`Total Pkgs`.toUpperCase(),
    $localize`# Total Stops with EDW`.toUpperCase(),
    $localize`# Total Stops EDW Met`.toUpperCase(),
    $localize`% Total Stops EDW Met`.toUpperCase(),
    $localize`# Committed Stops with EDW`.toUpperCase(),
    $localize`# Committed Stops EDW Met`.toUpperCase(),
    $localize`% Committed Stops EDW Met`.toUpperCase(),
  ],
  DATA_FIELDS: [
    'location',
    'name',
    'totalStops',
    'totalPkgs',
    'numOfTotalStopswithEDW',
    'numOfTotalStopsEDWMet',
    'percentOfTotalStopsEDWMet',
    'numOfCommittedStopswithEDW',
    'numOfCommittedStopsEDWMet',
    'percentOfCommittedStopsEDWMet',
  ] as (keyof GroupEDWSummary)[],
};

export const CSV_FILE_COLUMN_HEADING = [
  `Location`,
  `Name`,
  `Total Stops`,
  `Total Pkgs`,
  `# Total Stops with EDW`,
  `# Total Stops EDW Met`,
  `% Total Stops EDW Met`,
  `# Committed Stops with EDW`,
  `# Committed Stops EDW Met`,
  `% Committed Stops EDW Met`,
];

type GroupEdwFormField = {
  date: FormControl<Date>;
  reportFormat: FormControl<Options>;
};

export type GroupEdwFormGroup = FormGroup<GroupEdwFormField> | null;
